import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@api/core';
import { EvaluationShowType, IPersonEvaluationFA5C } from './evaluation.model';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const API_URL = 'evaluation';
const API_URL_EVALUATIONS = 'evaluations'
@Injectable()
export class EvaluationApiService {
  constructor(private api: ApiService, private http: HttpClient) { }

  getEvaluatedPersons(segmentId: number, fromDate: string, toDate: string): Observable<IPersonEvaluationFA5C[]> {
    const body = { segmentId, fromDate, toDate };
    return this.api.post<IPersonEvaluationFA5C[]>(API_URL, '/medical-evaluations/filter-segment', body);
  }

  getEvaluation(patientId: string): Observable<any> {
    return this.api.get(API_URL, '/medical-evaluations/lasts' + '/' + patientId);
  }

  getSummary(patientId: string, instituteId: string): Observable<any> {
    return this.api.get(API_URL, '/medical-evaluations/bodyComposition/summaryEvaluation'
      + '?instituteId=' + instituteId + '&patientId=' + patientId);
  }

  deleteEvaluation(medicalConsultationId: number): Observable<any> {
    return this.api.delete(API_URL, `/medical-evaluations/${medicalConsultationId}`);
  }

  getSixFold(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('sixFold', patientId, instituteId, sinceDate, toDate);
  }
  getIndexMOTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('indexMO', patientId, instituteId, sinceDate, toDate);
  }
  getMuscleMassTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('muscleMass', patientId, instituteId, sinceDate, toDate);
  }
  getFatMassTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('fatMass', patientId, instituteId, sinceDate, toDate);
  }
  getBoneMassTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('boneMass', patientId, instituteId, sinceDate, toDate);
  }
  getWeightTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('weight', patientId, instituteId, sinceDate, toDate);
  }
  getImgtTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('imgt', patientId, instituteId, sinceDate, toDate);
  }
  getImlgtTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('imlgt', patientId, instituteId, sinceDate, toDate);
  }
  getMgPercentileTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('mgPercentile', patientId, instituteId, sinceDate, toDate);
  }
  getMlgPercentileTimeLine(patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.getTimeLine('mlgPercentile', patientId, instituteId, sinceDate, toDate);
  }
  getTimeLine(type: string, patientId: string, instituteId: string, sinceDate: string, toDate: string): Observable<any> {
    return this.api.get(API_URL, '/timelines/' + type + '?instituteId=' + instituteId + '&patientId=' + patientId);
  }

  getShowTypesEvaluations(patientId: number): Observable<EvaluationShowType> {
    return this.api.get<any>(API_URL, `/medical-evaluations/showTypesEvaluations/?patientId=${patientId}`).pipe(map(data => {
      return data.type;
    }));
  }

  getDinamicEvaluations(patientsIds: Array<string>, type: string, toDate: string, sinceDate: string, order: string, allEvaluations: boolean) {
    let params = '';
    patientsIds.forEach((p: string, index) => {
      params += `${index === 0 ? '?' : '&'}patientIds=${p}`;

    });
    if (toDate)
      params += `&toDate=${toDate}`;
    if (sinceDate)
      params += `&sinceDate=${sinceDate}`;


    params += `&order=${order}`
    params += `&allEvaluations=${allEvaluations}`


    return this.api.get<any>(API_URL, `/medical-evaluations/evaluations/bulk/${type}${params}`)
  }
}
